import { injectable, inject } from 'inversify';
import { CommandContribution, CommandRegistry, Command, ILogger, MessageService } from '@theia/core/lib/common';
import { WorkspaceService } from '@theia/workspace/lib/browser/workspace-service';

declare global {
    interface Window {
        __userData: {
            entityGuid: string,
            sessionId: string
        };
    }
}

const TriggerPushCommand: Command = {
    id: 'trigger.publish.firmware.command',
    label: 'Publish Firmware'
};

@injectable()
export class TriggerPushCommandContribution implements CommandContribution {
    @inject(ILogger)
    private readonly logger: ILogger;
    @inject(WorkspaceService)
    private readonly workspace: WorkspaceService;
    @inject(MessageService)
    private readonly messageService: MessageService;

    registerCommands(registry: CommandRegistry): void {
        registry.registerCommand(TriggerPushCommand, {
            execute: async () => {
                const userData = window.__userData;
                if (!userData) {
                    this.logger.warn('UserData was not found.');
                    return;
                }

                this.logger.debug('Getting workspace roots...');

                const workspaceRoots = await this.workspace.roots;
                const workspaceRoot = workspaceRoots[0];
                this.logger.info(workspaceRoots.map(root => root.name));

                try {
                    this.messageService.info(`Publishing the firmware...`);
                    this.logger.debug('Calling /push-firmware');

                    const pushResponse = await fetch('./push-firmware', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            workspaceRoot: workspaceRoot.resource.path.toString(),
                            entityGuid: userData.entityGuid,
                            sessionId: userData.sessionId
                        })
                    });

                    const result = await pushResponse.json();

                    if (result.ok) {

                        this.logger.info('Firmware push triggered.');
                        this.messageService.info(`The firmware has been published.`);

                    } else {
                        this.logger.warn(`Firmware push failed: ${result?.error ?? String(result)}`);
                        this.messageService.error(`The firmware: ${result?.error ?? String(result)}`);
                    }
                } catch (error: any) {

                }
            }
        });
    }
}